import { faMobile, faMobileAndroid, faMobilePhone, faMobileRetro, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from "../images/logo.png";
import horo from "../images/services/kundali.webp";
import kundlai from "../images/services/kundali-analys.webp";
import marriage from "../images/services/marriage.jpg";
import career from "../images/services/career.jpg";
import finance from "../images/services/finance.jpg";
import health from "../images/services/health.jpg";
import mahurt from "../images/services/mahurt.jpg";

import { faPhone } from "@fortawesome/free-solid-svg-icons/faPhone";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faMobileAndroidAlt } from "@fortawesome/free-solid-svg-icons/faMobileAndroidAlt";
import { Innerbanner } from "./innerbanner";
import { Link } from "react-router-dom";


function Topheader(){
 
return(

<div>

<section className="container-fluid bg-danger p-2 text-center text-white shadow">
 

    <FontAwesomeIcon icon={faMobileAndroidAlt} className="pt-2 "></FontAwesomeIcon> +91 9873336259 &nbsp;&nbsp;

       <FontAwesomeIcon icon={faWhatsapp} className="pt-2 "></FontAwesomeIcon> +91 9873336259
      
     
   

 
</section>




<section  className="container">



  <nav className="navbar navbar-expand-lg navbar-light ">
    <div className="container-fluid"> <a className="navbar-brand" href="#"><img src={logo}/></a>
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"> <span className="navbar-toggler-icon"></span> </button>
      <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
        <ul className="navbar-nav  mb-2 mb-lg-0">
          <li className="nav-item"> <Link  className="nav-link active" aria-current="page" to="/">Home</Link> </li>
          
          <li className="nav-item dropi" > 
            
            
            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"> Services </a>
           
           <div className="dropdown-menu container" aria-labelledby="navbarDropdown">
           <div class="drop">
            
            <div class="dropitem animate__animated animate__fadeInDown">
            <div class="link-wrap"><Link to="/kundalianalysis" className="link">
          
            <img src={kundlai} loading="lazy" alt="rpa" className="img-fluid  rounded rounded-4"/></Link></div>
            <div class="menu-text"><Link to="/kundalianalysis">
            <p>Horscopes Analyis</p></Link>
            <div className="d-inline-flex gap-1">
            <Link to="/kundalianalysis"><button className="btn btn-danger">MORE</button></Link>
             <Link to="/contactus"><button className="btn  btn-danger ">Contact</button></Link>
              
              </div>
              
              </div></div>




              <div class="dropitem animate__animated animate__fadeInDown" style={{animationDelay: '0.1s'}} ><div class="link-wrap">
              <Link to="/kundalimatching">
                <img src={horo} loading="lazy" alt="qa" className="img-fluid  rounded rounded-4"/></Link></div>
                <div class="menu-text"><Link to="/kundalimatching" style={{ textDecoration:'none'}}><p>Kundali Matching</p></Link>
                <div className="d-inline-flex gap-1">
                <Link to="/kundalimatching"><button className="btn btn-danger">MORE</button></Link>
                <Link to="/robotic_process_automation?Rpacontact"><button className="btn  btn-danger ">Contact</button></Link>
              
              </div></div></div>
                <div class="dropitem animate__animated animate__fadeInDown" style={{animationDelay: '0.2s'}} ><div class="link-wrap">
                <Link to="/relationship">
                  <img src={marriage } loading="lazy" alt="scrum" className="img-fluid  rounded rounded-4"/></Link></div>
                  <div class="menu-text"><Link to="/relationship" style={{ textDecoration:'none'}}><p>Maarriage and Relationship </p></Link>
                  <div className="d-inline-flex gap-1">
                  <Link to="/relationship"><button className="btn btn-danger">MORE</button></Link>
                  <Link to="/contactus"><button className="btn  btn-danger ">Contact</button></Link>
              
              </div></div></div>
                  <div class="dropitem animate__animated animate__fadeInDown" style={{animationDelay: '0.3s'}} ><div class="link-wrap">
                    <a href="/Career-Guidance"><img src={career} loading="lazy" alt="staff" className="img-fluid  rounded rounded-4"/></a></div>
                    
                    <div class="menu-text">
                    <Link to href="/Career-Guidance" style={{ textDecoration:'none'}}>
                    <p>Job and Career Guidance</p></Link>
                    <div className="d-inline-flex gap-1">
                    <Link to="/Career-Guidance"><button className="btn btn-danger">MORE</button></Link>
                    <Link to="/contactus"><button className="btn  btn-danger ">Contact</button></Link>
              
              </div></div>
                    </div>
                    
                    <div class="dropitem animate__animated animate__fadeInDown" style={{animationDelay: '0.4s'}} >
                      <div class="link-wrap"><Link to="/business-and-finance">
                      <img src={finance} loading="lazy" alt="digi" className="img-fluid  rounded rounded-4"/></Link></div>
                      <div class="menu-text"><Link to="/business-and-finance"  style={{ textDecoration:'none'}}>
                      <p>Business and Finance</p></Link>
                      
                      <div className="d-inline-flex gap-1">
                      <Link to="/business-and-finance"><button className="btn btn-danger">MORE</button></Link>
                      <Link to="/contactus"><button className="btn  btn-danger ">Contact</button></Link>
              
              </div>
                      
                      
                      
                      </div></div>
                      <div class="dropitem animate__animated animate__fadeInDown" style={{animationDelay: '0.2s'}}>
                        <div class="link-wrap"><Link to href="/medical-astrology">
                        <img src={health} loading="lazy" alt="staff" className="img-fluid  rounded rounded-4"/></Link>
                      </div><div class="menu-text"><Link to="/medical-astrology" style={{ textDecoration:'none'}}>
                      <p>Health Problem</p></Link>
                      <div className="d-inline-flex gap-1">
                      <Link to="/medical-astrology"><button className="btn btn-danger">MORE</button></Link>
              <Link to="/contactus"><button className="btn  btn-danger ">Contact</button></Link>
              
              </div>
                      
                      
                      </div></div>
                      <div class="dropitem animate__animated animate__fadeInDown" style={{animationDelay: '0.2s'}}>
                        <div class="link-wrap"><Link to="/muhart">
                <img src={mahurt} loading="lazy" alt="qa" className="img-fluid  rounded rounded-4"/></Link></div>
                <div class="menu-text">
                <Link to="/muhart" style={{ textDecoration:'none'}}><p>
                  Auspicious Day (Muhart)</p></Link>
                  
                  <div className="d-inline-flex gap-1">
                  <Link to="/muhart"><button className="btn btn-danger">MORE</button></Link>
                  <Link to="/contactus"><button className="btn  btn-danger ">Contact</button></Link>
              
              </div>
                    
                    </div></div></div>
</div>


</li>
         
          <li className="nav-item"> <Link className="nav-link" t0="/astrologergurgaon"> About Me</Link> </li>
          <li className="nav-item"> <Link className="nav-link" to="/contactus">Contact US</Link> </li>
        </ul>
        <form className="d-flex pe-2">
          <a className="btn  text-white rounded-4 me-3 fw-semibold btn-dark">GET IN TOUCH</a> <a className="btn  text-white fw-semibold rounded-4 btn-danger" >Appoitment</a>
        </form>
      </div>
    </div>
  </nav>


</section>

</div>
)


}


export { Topheader};

